/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ratelimitGetOverride } from "../../funcs/ratelimitGetOverride.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.V2RatelimitGetOverrideRequestBody$inboundSchema,
};

export const tool$ratelimitGetOverride: ToolDefinition<typeof args> = {
  name: "ratelimit-get-override",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await ratelimitGetOverride(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
